module.exports = __webpack_public_path__ + "img/real-estate-background.d9ab37fe.jpg";